  <template>
  <div class="pt-3 flex items-center mb-4">
    <slot></slot>
    <vs-switch :color="value ? 'success' : 'danger'"
               :value="value"
               @input="update"
    >
        <template v-slot:on>
          <slot name="on">
            Yes
          </slot>
        </template>
      <template v-slot:off>
        <slot name="off">
          No
        </slot>
      </template>
    </vs-switch>
  </div>
</template>

<script>
export default {
  name: "YesNoToggle",
  props: {
    value: {
      default: false,
      required: true,
    },
  },
  methods: {
    update(value) {
      this.$emit('input', value);
    }
  },
};
</script>
